export const drawBackground = (ctx, canvas, img) => {
  if (!img) {
    ctx.fillStyle = '#0a0a0a';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    return;
  }
  const cR = canvas.width / canvas.height;
  const iR = img.width / img.height;
  let dW, dH, dX, dY;

  if (iR > cR) {
    dH = canvas.height; dW = img.width * (canvas.height / img.height);
    dX = (canvas.width - dW) / 2; dY = 0;
  } else {
    dW = canvas.width; dH = img.height * (canvas.width / img.width);
    dX = 0; dY = (canvas.height - dH) / 2;
  }
  ctx.drawImage(img, dX, dY, dW, dH);
  ctx.fillStyle = "rgba(15, 23, 42, 0.6)"; 
  ctx.fillRect(0, 0, canvas.width, canvas.height);
};

export const drawAvatar = (ctx, canvas, dataArray, avatarImg, aspectRatio) => {
  if (!avatarImg) return;
  const average = dataArray.reduce((a, b) => a + b) / dataArray.length;
  const volumeBoost = average / 255;
  const scale = 1 + (volumeBoost * 0.2);
  const size = aspectRatio === 'landscape' ? 140 : 180;

  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.scale(scale, scale);
  ctx.shadowBlur = 25; ctx.shadowColor = '#f59e0b';
  ctx.beginPath(); ctx.arc(0, 0, size / 2 + 6, 0, Math.PI * 2); ctx.fillStyle = "#f59e0b"; ctx.fill();
  ctx.beginPath(); ctx.arc(0, 0, size / 2, 0, Math.PI * 2); ctx.clip();
  ctx.drawImage(avatarImg, -size / 2, -size / 2, size, size);
  ctx.restore();
};

export const VisualLibrary = {
  bars: (ctx, dA, canvas) => {
    const w = (canvas.width / dA.length) * 2.5;
    for (let i = 0; i < dA.length; i++) {
      const h = (dA[i] / 255) * (canvas.height * 0.35);
      ctx.fillStyle = `rgba(245, 158, 11, ${dA[i]/255 + 0.3})`;
      ctx.fillRect(i * w, canvas.height - h, w - 2, h);
    }
  },

  circle: (ctx, dA, canvas) => {
    const cX = canvas.width / 2; const cY = canvas.height / 2;
    const r = Math.min(canvas.width, canvas.height) * 0.22;
    for (let i = 0; i < dA.length; i++) {
      const h = (dA[i] / 255) * 100; const a = (i * 2 * Math.PI) / dA.length;
      ctx.strokeStyle = `hsl(${40 + dA[i]/5}, 100%, 50%)`; ctx.lineWidth = 4;
      ctx.beginPath(); ctx.moveTo(cX + Math.cos(a) * r, cY + Math.sin(a) * r);
      ctx.lineTo(cX + Math.cos(a) * (r + h), cY + Math.sin(a) * (r + h)); ctx.stroke();
    }
  },

  wave: (ctx, dA, canvas) => {
    ctx.beginPath();
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#f59e0b';
    const sliceWidth = canvas.width / dA.length;
    let x = 0;
    for (let i = 0; i < dA.length; i++) {
      const v = dA[i] / 128.0;
      const y = (v * canvas.height) / 2.5 + (canvas.height / 4);
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
      x += sliceWidth;
    }
    ctx.stroke();
  },

  mirror: (ctx, dA, canvas) => {
    const w = (canvas.width / dA.length) * 2;
    const center = canvas.height / 2;
    for (let i = 0; i < dA.length; i++) {
      const h = (dA[i] / 255) * (canvas.height * 0.2);
      ctx.fillStyle = `rgba(245, 158, 11, ${dA[i]/255 + 0.4})`;
      ctx.fillRect(i * w, center - h, w - 2, h * 2);
    }
  },

  rain: (ctx, dA, canvas) => {
    const w = canvas.width / 50;
    for (let i = 0; i < 50; i++) {
      const h = (dA[i * 2] / 255) * canvas.height;
      ctx.fillStyle = `rgba(245, 158, 11, 0.5)`;
      ctx.fillRect(i * w * 1.5, 0, 2, h);
    }
  },

  pulse: (ctx, dA, canvas) => {
    const avg = dA.reduce((a, b) => a + b) / dA.length;
    const r = (avg / 255) * (canvas.width * 0.4);
    ctx.beginPath();
    ctx.arc(canvas.width / 2, canvas.height / 2, r, 0, Math.PI * 2);
    ctx.lineWidth = 10;
    ctx.strokeStyle = `rgba(245, 158, 11, ${avg/255})`;
    ctx.stroke();
  },

  helix: (ctx, dA, canvas) => {
    const w = canvas.width / dA.length;
    for (let i = 0; i < dA.length; i++) {
      const h = (dA[i] / 255) * 100;
      const y = canvas.height / 2 + Math.sin(i * 0.1) * 50;
      ctx.fillStyle = '#f59e0b';
      ctx.beginPath();
      ctx.arc(i * w * 2, y + h, 3, 0, Math.PI * 2);
      ctx.arc(i * w * 2, y - h, 3, 0, Math.PI * 2);
      ctx.fill();
    }
  },

  grid: (ctx, dA, canvas) => {
    const size = 40;
    const cols = Math.floor(canvas.width / size);
    const rows = Math.floor(canvas.height / size);
    for (let i = 0; i < cols; i++) {
      for (let j = 0; j < rows; j++) {
        const val = dA[(i + j) % dA.length];
        ctx.fillStyle = `rgba(245, 158, 11, ${val / 500})`;
        ctx.fillRect(i * size, j * size, size - 2, size - 2);
      }
    }
  },

  particles: (ctx, dA, canvas) => {
    for (let i = 0; i < 30; i++) {
      const val = dA[i * 4];
      const x = (i / 30) * canvas.width;
      const y = canvas.height - (val / 255) * canvas.height;
      ctx.fillStyle = '#f59e0b';
      ctx.beginPath();
      ctx.arc(x, y, val / 40, 0, Math.PI * 2);
      ctx.fill();
    }
  },

  dual: (ctx, dA, canvas) => {
    const w = (canvas.width / dA.length) * 2.5;
    for (let i = 0; i < dA.length; i++) {
      const h = (dA[i] / 255) * (canvas.height * 0.15);
      ctx.fillStyle = '#f59e0b';
      ctx.fillRect(i * w, 0, w - 2, h); // Top
      ctx.fillRect(i * w, canvas.height - h, w - 2, h); // Bottom
    }
  },

  stars: (ctx, dA, canvas) => {
    const avg = dA.reduce((a, b) => a + b) / dA.length;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    for (let i = 0; i < 20; i++) {
      const angle = (i / 20) * Math.PI * 2;
      const dist = (dA[i * 5] / 255) * (canvas.width * 0.5);
      ctx.fillStyle = '#f59e0b';
      ctx.beginPath();
      ctx.arc(centerX + Math.cos(angle) * dist, centerY + Math.sin(angle) * dist, 4, 0, Math.PI * 2);
      ctx.fill();
    }
  },

  steps: (ctx, dA, canvas) => {
    const stepCount = 20;
    const w = canvas.width / stepCount;
    for (let i = 0; i < stepCount; i++) {
      const val = dA[i * 8];
      const h = (val / 255) * (canvas.height * 0.5);
      ctx.strokeStyle = '#f59e0b';
      ctx.lineWidth = 10;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(i * w + w / 2, canvas.height / 2 - h / 2);
      ctx.lineTo(i * w + w / 2, canvas.height / 2 + h / 2);
      ctx.stroke();
    }
  },

  blocks: (ctx, dA, canvas) => {
    const size = 15;
    const spacing = 5;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    for (let i = 0; i < 15; i++) {
      const val = dA[i * 10];
      const offset = (val / 255) * 150;
      ctx.fillStyle = `rgba(245, 158, 11, ${val / 255})`;
      ctx.fillRect(centerX + offset, centerY - (i * (size + spacing)), size, size);
      ctx.fillRect(centerX - offset - size, centerY - (i * (size + spacing)), size, size);
      ctx.fillRect(centerX + offset, centerY + (i * (spacing)), size, size);
      ctx.fillRect(centerX - offset - size, centerY + (i * (spacing)), size, size);
    }
  },

  orbit: (ctx, dA, canvas) => {
    const time = Date.now() * 0.002;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    for (let i = 0; i < 12; i++) {
      const val = dA[i * 15];
      const angle = (i * Math.PI * 2) / 12 + time;
      const radius = 150 + (val / 2);
      ctx.fillStyle = '#f59e0b';
      ctx.beginPath();
      ctx.arc(centerX + Math.cos(angle) * radius, centerY + Math.sin(angle) * radius, 6, 0, Math.PI * 2);
      ctx.fill();
    }
  },

  spikes: (ctx, dA, canvas) => {
    ctx.beginPath();
    ctx.lineWidth = 3;
    ctx.strokeStyle = '#f59e0b';
    const step = canvas.width / 40;
    for (let i = 0; i < 40; i++) {
      const val = dA[i * 5];
      const x = i * step;
      const y = canvas.height - (val / 255) * 200;
      if (i === 0) ctx.moveTo(x, canvas.height);
      ctx.lineTo(x + step / 2, y);
      ctx.lineTo((i + 1) * step, canvas.height);
    }
    ctx.stroke();
  },

  bubbles: (ctx, dA, canvas) => {
    for (let i = 0; i < 15; i++) {
      const val = dA[i * 2];
      const x = (i / 15) * canvas.width + 20;
      const y = canvas.height - (val / 255) * canvas.height;
      ctx.strokeStyle = `rgba(245, 158, 11, ${val / 255})`;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.arc(x, y, val / 10, 0, Math.PI * 2);
      ctx.stroke();
    }
  },

  radar: (ctx, dA, canvas) => {
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const angle = (Date.now() * 0.005) % (Math.PI * 2);
    const radius = Math.max(canvas.width, canvas.height);
    const val = dA[10] / 2;
    ctx.strokeStyle = `rgba(245, 158, 11, 0.4)`;
    ctx.lineWidth = 2 + val / 10;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(centerX + Math.cos(angle) * radius, centerY + Math.sin(angle) * radius);
    ctx.stroke();
  },

  zigzag: (ctx, dA, canvas) => {
    ctx.beginPath();
    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = 4;
    let x = 0;
    const step = canvas.width / 20;
    for (let i = 0; i < 20; i++) {
      const val = (dA[i * 10] / 255) * 100;
      ctx.lineTo(x, canvas.height / 2 - val);
      x += step / 2;
      ctx.lineTo(x, canvas.height / 2 + val);
      x += step / 2;
    }
    ctx.stroke();
  },

  rays: (ctx, dA, canvas) => {
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    for (let i = 0; i < 36; i++) {
      const val = dA[i * 3];
      const angle = (i * Math.PI * 2) / 36;
      const length = 100 + (val / 255) * 300;
      ctx.strokeStyle = `rgba(245, 158, 11, ${val / 400})`;
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(centerX + Math.cos(angle) * length, centerY + Math.sin(angle) * length);
      ctx.stroke();
    }
  },

  glitch: (ctx, dA, canvas) => {
    for (let i = 0; i < 40; i++) {
      const val = dA[i * 4];
      const x = Math.random() * canvas.width;
      const y = (i / 40) * canvas.height;
      const length = (val / 255) * 100;
      ctx.fillStyle = '#f59e0b';
      ctx.fillRect(x, y, length, 2);
    }
  },

   tunnel: (ctx, dA, canvas) => {
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const avg = dA.reduce((a, b) => a + b) / dA.length;
    for (let i = 0; i < 5; i++) {
      const size = (i * 100) + (avg);
      ctx.strokeStyle = `rgba(245, 158, 11, ${1 - i / 5})`;
      ctx.lineWidth = 5;
      ctx.strokeRect(centerX - size / 2, centerY - size / 2, size, size);
    }
  },

  sidewaves: (ctx, dA, canvas) => {
    const step = canvas.height / 30;
    for (let i = 0; i < 30; i++) {
      const val = (dA[i * 5] / 255) * 100;
      ctx.fillStyle = `rgba(245, 158, 11, 0.6)`;
      ctx.fillRect(0, i * step, val, step - 2); 
      ctx.fillRect(canvas.width - val, i * step, val, step - 2);
    }
  }


  
};